import { useDispatch } from "react-redux";
import { onChangePolicyInformation, policyInformationType } from "../../features/ebam/plicy-data-page/policy-information/policy-information.slice";
import { usePolicyActions } from "./use-policy-actions";
import { usePolicyDataState } from "../policy/use-policy-data-state";

type PolicyCKEditorType =
    | "eligibleIndividuals"
    | "contribution"
    | "underwritingProvisionsNotes"
    | "specialUnderwritingProvisions";

export const useCKEditorActions = () => {

    const dispatch = useDispatch();
    const { 
        policyInformationType,
        policyEligibleIndividual,
        policyContribution,
        policyUnderwritingProvisionsNotes,
        policySpecialUnderwritingProvisions,
    } = usePolicyDataState()
    const { handleEditPolicyInformation, isLoadingUpdatePolicy } = usePolicyActions()

    // handleEditPolicyInformation
    const handleCKEditorSave = async () => {
        switch (policyInformationType) {
            case "eligibleIndividuals":
                await handleEditPolicyInformation('eligibleIndividuals');
                break;

            case "underwritingProvisionsNotes":
                await handleEditPolicyInformation('underwritingProvisionsNotes');
                break;
            
            case "contribution":
                await handleEditPolicyInformation('contribution');
                break;

            case "specialUnderwritingProvisions":
                await handleEditPolicyInformation('specialUnderwritingProvisions');
                break;

            default:
                break;
        }
    };

    const isCKEditorType = ( type: policyInformationType): type is PolicyCKEditorType => {
        return (
            type === "eligibleIndividuals" ||
            type === "contribution" ||
            type === "underwritingProvisionsNotes" || 
            type === "specialUnderwritingProvisions" 
        );
    };

    const getPolicyInformationTitle = ( type: PolicyCKEditorType ): string => {
        switch (type) {
            case "eligibleIndividuals":
                return "for eligible individuals";
            case "contribution":
                return "for contribution";
            case "underwritingProvisionsNotes":
                return "for underwriting provisions notes";
            case "specialUnderwritingProvisions":
                return "for special underwriting provisions notes";
            default:
                return "";
        }
    };

    const getPolicyInformationValue = ( type: PolicyCKEditorType ): string => {
        switch (type) {
            case "eligibleIndividuals":
                return policyEligibleIndividual ?? "";
            case "contribution":
                return policyContribution ?? "";
            case "underwritingProvisionsNotes":
                return policyUnderwritingProvisionsNotes ?? "";
            case "specialUnderwritingProvisions":
                return policySpecialUnderwritingProvisions ?? "";
            default:
                return "";
        }
    };

    const onChangeCKEditor = (value: string) => {
        if (!isCKEditorType(policyInformationType)) {
            return;
        }
        dispatch(onChangePolicyInformation({field: policyInformationType, value}));
    }

    return {
        handleCKEditorSave,
        isCKEditorType,
        getPolicyInformationTitle,
        getPolicyInformationValue,
        onChangeCKEditor,
        isLoadingUpdatePolicy
    }
}